// extracted by mini-css-extract-plugin
module.exports = {"step":"step__rmbLl","subtitle":"subtitle__OhYnH","content":"content__oWgco","text":"text__MmuI4","buttonContainer":"buttonContainer__sGFuk","okButton":"okButton__UUo1+"};